import styled from 'styled-components';
import * as Dialog from '@radix-ui/react-dialog';

import { white, gray, grayDarker, grayLight } from '@bufferapp/ui/style/colors';
import { Button, Notice } from '@bufferapp/ui';
import CrossIcon from '@bufferapp/ui/Icon/Icons/Cross';
import PencilIcon from '@bufferapp/ui/Icon/Icons/Pencil';
import MovieIcon from '@bufferapp/ui/Icon/Icons/Movie';

// This component a div insted of Dialog.Overlay
// Context: https://github.com/radix-ui/primitives/issues/1159
export const StyledOverlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgb(50, 59, 67, 0.8);
  opacity: 0.9;
  z-index: 3;
  pointer-events: initial;
`;

export const IdeatorWrapper = styled(Dialog.Content)`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  max-height: 850px;
  z-index: 3;
`;

export const IdeatorInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 632px;
  height: 100%;
  background-color: ${white};
  border-radius: 8px;
  position: relative;
`;

export const IdeatorContent = styled.div`
  margin: 40px;
  flex-grow: 1;
  font-size: 16px;
  line-height: 28px;
  color: ${grayDarker};
  overflow-y: auto;
  padding-right: 60px;

  [data-slate-placeholder='true'] {
    color: ${gray};
    opacity: 1 !important;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255);
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 20px 40px;
  border-top: 1px solid ${grayLight};
`;

export const StyledButton = styled(Button)`
  margin-left: 16px;
`;

export const CloseButton = styled(CrossIcon)`
  position: absolute;
  fill: ${white};
  top: -4px;
  right: -28px;
  cursor: pointer;
  width: 20px;
  height: 20px;
`;

export const StyledNotice = styled(Notice)`
  border-radius: 8px;
  width: calc(100% - 18px);
  position: absolute;
  top: -8px;
  transform: translateY(-100%);
`;

export const DeleteIcon = styled(CrossIcon)`
  position: absolute;
  cursor: pointer;
  fill: ${white};
  background-color: ${grayDarker};
  padding: 2px;
  top: 8px;
  right: 8px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
`;

export const EditIcon = styled(PencilIcon)`
  position: absolute;
  cursor: pointer;
  fill: ${white};
  background-color: ${grayDarker};
  padding: 2px;
  bottom: 8px;
  left: 8px;
  width: 20px;
  height: 20px;
  border-radius: 4px;
`;

export const PlayIcon = styled(MovieIcon)`
  position: absolute;
  cursor: pointer;
  fill: ${white};
  background-color: ${grayDarker};
  padding: 4px;
  bottom: 8px;
  left: 8px;
  width: 16px;
  height: 16px;
  border-radius: 4px;
`;

export const MediaManagerWrapper = styled.div`
  position: relative;

  #media-manager {
    padding: 0 40px;
  }
`;

export const IntegrationsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px 12px 40px;
`;
